import { makeCygnusApiCall } from "../../../../../api/api";

/**
 * Retrieves an engagement letter blob from the server.
 * @param fileName - Name of the file to download
 * @param containerName - Name of the container where the file is stored
 * @returns Blob of the engagement letter
 */
export const getEngagementLetter = async (
  fileName: string,
  containerName: string
): Promise<Blob> => {
  const url = `${process.env.REACT_APP_BASE_URI}/mdm/download/blob/?FileName=${encodeURIComponent(fileName)}&ContainerName=${encodeURIComponent(containerName)}`;

  const response = await makeCygnusApiCall({
    type: "GET",
    url,
    show_message: false,
    customized_success_message: "Engagement letter downloaded successfully.",
    customized_failure_message: "Failed to download engagement letter.",
    customized_error_message: "Error occurred while downloading engagement letter.",
    isblob: true,
    forMDM: true,
  });

  if (response instanceof Blob) {
    return response;
  } else {
    throw new Error("Invalid engagement letter response");
  }
};
